<small-screen-modal
  class="-overlay-container"
  [ngClass]="{ '-overlay-slide-in': sidebarShow }"
  (click)="sidebarEventHandler()"></small-screen-modal>
<span
  class="sidebar-slider"
  [class.sidebar-slide-in]="sidebarShow"
    [ngClass]="
    !meta
      ? '-no-sec-nav-offset'
      : (meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW ||
          meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW_FAMILY)
      ? '-no-sec-nav-offset'
      : isSecNav
      ? meta['subscription-group']
        ? '-sec-nav-with-release-notes-offset'
        : '-sec-nav-offset'
      : '-no-sec-nav-offset'
  ">
  @if (!navReady) {
  <left-nav-skeleton></left-nav-skeleton>
  }
  <!-- TODO: Remove the below two lines when new sidebar is implemented on all pages -->
  @if (renderer === 'legacy') {
    @if (!isSidebarPresent) {
    <nav-vertical-updated
      (initialized)="onNavReady($event)"
      [class.-nav-loading]="isInitialNavLoad && !navReady"
      [allowLoaderControl]="!!meta"
      [ngClass]="{
        '-doc-page-nav': isDocPageNav(),
        '-hide-sec-nav': !isSecNav,
        '-account': !meta
      }"
      slideNav="slideNav"></nav-vertical-updated>
    } @if (!isSidebarPresent) {
    <div class="sidebar-opener" (click)="sidebarEventHandler()"></div>
    } @if (isSidebarPresent) {
    <sidebar
      (initialized)="onNavReady($event)"
      [class.-nav-loading]="!navReady"
      [menu]="meta"
      [allowLoaderControl]="!!meta"
      [ngClass]="{
        '-doc-page-nav': isDocPageNav(),
        '-hide-sec-nav': !isSecNav,
        '-account': !meta
      }"
      slideNav="slideNav"></sidebar>
    }
  } @if (renderer === 'designtoken') {
    @if (!isSidebarPresent) {
    <app-nav-vertical-updated
      (initialized)="onNavReady($event)"
      [class.-nav-loading]="!navReady"
      [allowLoaderControl]="!!meta"
      [ngClass]="{
        '-doc-page-nav': isDocPageNav(),
        '-hide-sec-nav': !isSecNav,
        '-account': !meta
      }"
      slideNav="slideNav"></app-nav-vertical-updated>
    } @if (!isSidebarPresent) {
    <div class="sidebar-opener" (click)="sidebarEventHandler()"></div>
    } @if (isSidebarPresent) {
    <app-sidebar
      (initialized)="onNavReady($event)"
      [class.-nav-loading]="!navReady"
      [menu]="meta"
      [allowLoaderControl]="!!meta"
      [ngClass]="{
        '-doc-page-nav': isDocPageNav(),
        '-hide-sec-nav': !isSecNav,
        '-account': !meta
      }"
      slideNav="slideNav"></app-sidebar>
    }
  }
</span>
